import * as CONST from './const'

/**
 * Get legal documents
 *
 * @returns {{type}}
 */
export function getLegalDocuments() {
  return {
    type: CONST.GET_LEGAL_DOCUMENTS,
  }
}

/**
 * Get legal document by id
 *
 * @returns {{type}}
 */
export function getLegalDocumentById(id) {
  return {
    type: CONST.GET_LEGAL_DOCUMENT_BY_ID,
    payload: { id },
  }
}

/**
 * Create legal document
 *
 * @param callbacks
 * @param payload
 * @returns {{type, payload: *}}
 */
export function createLegalDocument(fields) {
  return {
    type: CONST.CREATE_LEGAL_DOCUMENT,
    payload: fields,
  }
}

/**
 * Update legal document by id
 *
 * @param id
 * @param payload
 * @returns {{type, id: *, payload: *}}
 */
export function updateLegalDocumentById(id, fields) {
  return {
    type: CONST.UPDATE_LEGAL_DOCUMENT_BY_ID,

    payload: { ...fields, id },
  }
}

/**
 * Delete legal document
 *
 * @param payload
 * @returns {{type, payload: *}}
 */
export function deleteLegalDocumentById(id) {
  return {
    type: CONST.DELETE_LEGAL_DOCUMENT_BY_ID,
    payload: { id },
  }
}
